import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Eta from "../../components/general/Eta";
import Slider from "./Slider";
import ProductFamilies from "./ProductFamilies";
import { fetchContent } from "../../redux/slices/contentSlice";
import { fetchSeo } from "../../redux/slices/seoSlice";

const HomePage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const { dataContent } = useSelector((state) => state.content);
  const { dataSeo } = useSelector((state) => state.seo);
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    dispatch(fetchContent());
    dispatch(fetchSeo());
  }, [dispatch]);

  useEffect(() => {
    const setSeoContent = async () => {
      if (dataSeo?.length > 0) {
        const homeData = dataSeo.find(
          (item) =>
            item.title[lang] === "Anasayfa" || item.title[lang] === "Homepage"
        );
        if (homeData) {
          setSeoData(homeData);
          document.title = homeData.title[lang];
        }
      }
    };

    setSeoContent();
  }, [dataSeo, lang]);

  return (
    <Eta>
      {seoData && (
        <Helmet>
          <title>{seoData.title[lang]}</title>
          <meta name="description" content={seoData.description[lang]} />
          {seoData.keywords[lang] && (
            <meta name="keywords" content={seoData.keywords[lang]} />
          )}
          {seoData.canonical && (
            <link rel="canonical" href={seoData.canonical} />
          )}
          {seoData.author && <meta name="author" content={seoData.author} />}
        </Helmet>
      )}
      <Slider />
      <ProductFamilies />
    </Eta>
  );
};

export default HomePage;
